import { ToFloat } from './utils';

export function getQuantumAmount(data: IMoney.BudgetAmount) {
  return ToFloat(data.stateBudgetAmount) + ToFloat(data.localBudgetAmount);
}